import React, { PropTypes } from "react";
import AmazonLinkTo from "./AmazonLinkTo";
import FormattedHeightLimit from "./Descriptions/FormattedHeightLimit";
import FormattedWeightLimit from "./Descriptions/FormattedWeightLimit";

const ClothingSize = ({ brand, gender, size }) => {
  return (
    <tbody>
      <tr>
        <td>{size.size}</td>
        <td className="text-right">
          <FormattedHeightLimit size={size} />
        </td>
        <td className="text-right">
          <FormattedWeightLimit size={size} />
        </td>
      </tr>
      <tr>
        <td colSpan="3" className="text-center">
          <AmazonLinkTo brand={brand} size={size} gender={gender} linkText={`Find ${brand.name} ${size.size} on Amazon`} />
        </td>
      </tr>
    </tbody>
  );
};

ClothingSize.propTypes = {
  brand: PropTypes.object.isRequired,
  gender: PropTypes.string.isRequired,
  size: PropTypes.object.isRequired,
};

export default ClothingSize;


/** WEBPACK FOOTER **
 ** ./src/components/AvailableSizes/ClothingContainer/ClothingSize.js
 **/